import React, { useRef, useState, useMemo, useEffect } from 'react';
import "./styles.css";
import { Alert, Button, Input, Popover, PopoverHeader, PopoverBody, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FaFileExcel, FaFilePdf, FaCheck, FaUserCog, FaPrint, FaSignOutAlt, FaFileDownload, FaFileCode, FaFileImage } from "react-icons/fa";
import { getCookie, handleToggleColumn, RelevantIcon, groupServerData, toAngle } from '../../../components/oro-module/commonFunctions';
import { controls, currencyToNumber } from '../../controls';
import { createComponent } from '../../../components/FormArea/FormContent';
import { ToggleCustom } from '../../../components/FormComponents';
import chroma from 'chroma-js';
import { CSVLink, CSVDownload } from "react-csv";


const shareBtn = () => {
  return <div>Share</div>
}

const ChartSettings = ({ chartType, props }) => {
  // Show the settings required to manipulate the chart.
  // Start with column/row. * VALUE Column / row. Pivot -> start with column/row.
  let {
    currentPage,
    formElements,
    OriginalData,
    pieSliceClicked
  } = props.parentState;
  let { history } = formElements[currentPage];
  let { charts } = history;
  // Save all of these to parentState.
  let [rowWise, setRowWise] = useState(true);
  let [showVar2, setShowVar2] = useState(false);
  let [isDrillDown, setDrillDown] = useState(false);
  let [valField, setValField] = useState(false);



  const convertToPieChartData = ({ combinedData, history, level = 1, parentData = {} }) => {

    let retdata = [];
    let { targetfield, flabel } = charts['pie']['row'];

    let lst = combinedData[combinedData.length - 1];
    let totval = 0;
    if (level == 1) {
      if (lst['skip_rows'] == 'grand_total') { totval = currencyToNumber(lst[targetfield]) };
    } else {
      totval = currencyToNumber(parentData[targetfield]);
    }


    for (var i = 0; i < combinedData.length; i++) {
      let cd = combinedData[i];
      if (cd['skip_rows'] != 'grand_total') {
        let slicedata = {};
        let curval = currencyToNumber(cd[targetfield]);
        slicedata['value'] = curval;
        slicedata['label'] = cd[flabel];
        slicedata['rowdata'] = cd;
        // slicedata['index'] = i;


        // if (cd.subRows) {
        //   slicedata['drilldown'] = setClicked;
        // }
        // slicedata['padAngle'] = 0.01;

        // slicedata['startAngle'] = toAngle(Math.min(startAngle, 360));
        // slicedata['endAngle'] = toAngle(Math.min(startAngle + angleArea, 360));
        // startAngle += angleArea;

        if (cd.subRows) {
          slicedata['subRows'] = convertToPieChartData({ combinedData: cd.subRows, history, level: level + 1, parentData: cd });
        }
        retdata.push(slicedata);
      }
    }
    return retdata;
  }


  const generatePieChartData = ({ history, serverData, current }) => {
    let combinedData = groupServerData({ serverData, history, current });
    let chartData = convertToPieChartData({ combinedData, history });
    let colors = [...Array(100).keys()].map(r => chroma.random());

    return { chartData, colors };
  }

  let chartingData = useMemo(() => generatePieChartData({ serverData: OriginalData, current: { props }, history }), [chartType, rowWise, OriginalData, pieSliceClicked]);

  let allc = [
    ...controls.piechart({ width: "col-sm-6", dims: { cw: 40, ch: 40 }, data: chartingData }),
  ]

  const handleRowWise = () => {
    if (!rowWise) {

    }
    setRowWise(!rowWise);
  }

  return (
    <div>
      {chartType == 'pie' &&
        <div className="row">
          <div className="col-sm-6">
            <ToggleCustom isChecked={rowWise} display={rowWise ? "Row" : "Column"} setChecked={handleRowWise} />
          </div>
          <div className="col-sm-6">
            <ToggleCustom isChecked={showVar2} display={showVar2 ? "Nested" : "Simple"} setChecked={() => setShowVar2(!showVar2)} />
          </div>
          <div className="col-sm-6">
            <ToggleCustom isChecked={isDrillDown} display={isDrillDown ? "Drilldown" : "Fixed"} setChecked={() => setDrillDown(!isDrillDown)} />
          </div>
          {createComponent({ allc, selectedFormTab: "", current: { props } })}
        </div>
      }
    </div>
  )
}

const setPageOrientation = (e, props) => {
  let { fileFolder } = props.parentState;
  fileFolder.pageOrientation = e.target.value;
  props.liftGlobalState({ name: "fileFolder" }, fileFolder);
};
const setPageSize = (e, props) => {
  let { fileFolder } = props.parentState;
  fileFolder.pageSize = e.target.value;
  props.liftGlobalState({ name: "fileFolder" }, fileFolder);
};

const clickButton = (id) => {
  let elem = document.getElementById(id);
  if (elem) {
    elem.click();
  }
}

const useOutsideAlerter = (ref, cur) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        cur.liftGlobalState({ name: "showGeneralControl" }, false);
        cur.liftGlobalState({ name: "rightSidebarOpen" }, false);
        cur.liftGlobalState({ name: "chartBoxOpen" }, false);

      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const GeneralControls = (props) => {
  let {
    currentPage,
    formElements,
    LocalVars,
    rightSidebarOpen,
    showGeneralControl,
    chartBoxOpen,
    historyTableParams,
    fileFolder,
    pdfdownloading,
    pdfdownloadingfull,
    textdownloading,
    textPageSize
  } = props.parentState;

  let [shareopt, setShareopt] = useState(false);
  let [mobile, setMobile] = useState('');
  let [email, setEmail] = useState('');

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props);

  let history = formElements[currentPage] ? formElements[currentPage].history : null;
  let pdfProps = history && history.pdfProps ? history.pdfProps : {};
  let textReportProps = history ? history.textReportProps : null;
  let pivot = history ? history.pivot : null;
  let lgs = props.liftGlobalState;

  let { hiddenColumns } = LocalVars;
  let shownColumns = getCookie('allColumns');
  let allColumns = shownColumns ? JSON.parse(shownColumns) : [];
  let chartOptions = [
    { id: 'pie', label: "Pie", icon: "piechart-color", desc: "" },
    { id: 'bar', label: "Bar", icon: "bar-chart", desc: "" },
    { id: 'line', label: "Line", icon: "stock-chart", desc: "" },
    { id: 'area', label: "Area", icon: "area-chart", desc: "" },
    { id: 'scatter', label: "Scatter", icon: "scatter-plot", desc: "" },
    { id: 'surface', label: "Surface", icon: "surface-chart", desc: "" },
    { id: 'doughnut', label: "Doughnut", icon: "doughnut-chart", desc: "" },
    { id: 'bubble', label: "Bubble", icon: "bubble-chart", desc: "" },
    { id: 'radar', label: "Radar", icon: "radar-chart", desc: "" },
    { id: 'candle', label: "Candle", icon: "candle-plot", desc: "" },
    { id: 'gantt', label: "Gantt", icon: "gantt-chart", desc: "", style: { height: 50, marginBottom: 8 } },
  ];

  let shareOptions = [
    { id: 'whatsapp', label: "WhatsApp", icon: "whatsapp", desc: "" },
    { id: 'email', label: "E-Mail", icon: "email", desc: "" },
    // { id: 'app', label: "App", icon: "stock-chart", desc: "" }
  ];


  const handleShareClick = (id) => {
    setShareopt(shareopt == id ? false : id);
  }
  const handleShare = (by) => {

  }


  const handleChartClick = (id) => {
    if (chartBoxOpen && chartBoxOpen == id) {
      lgs({ name: 'chartBoxOpen' }, false);
    } else {
      lgs({ name: 'chartBoxOpen' }, id);
    }
  }

  useEffect(() => {
    setPageOrientation({ target: { value: pdfProps.pageOrientation } }, props);
    setPageSize({ target: { value: pdfProps.pageSize } }, props);
  }, [pdfProps])


  return (

    <div>
      {showGeneralControl &&


        <div
          className="row"
          id="general-controls"
          ref={wrapperRef}
        >
          <div className="col-sm-12" style={{ padding: 2 }}>
            <div id="popover-describer">
              {rightSidebarOpen == 'history' &&
                <div>History</div>
              }
              {rightSidebarOpen == 'table' &&
                <div>Present</div>
              }
              {rightSidebarOpen == 'print' &&
                <div>Print</div>
              }
              {rightSidebarOpen == 'share' &&
                <div>Share</div>
              }
              {rightSidebarOpen == 'charting' && !chartBoxOpen &&
                <div>Select Chart</div>
              }
              {rightSidebarOpen == 'charting' && chartBoxOpen &&
                <div className="col-sm-12 hand" onClick={() => lgs({ name: 'chartBoxOpen' }, false)}>
                  <RelevantIcon icon="back-arrow" style={{ color: "#3282b8", fontSize: 20 }} />
                </div>
              }
            </div>
          </div>

          {/* Display all the controls possible */}
          {/* Show controls relevant to the currentPage & selected control.*/}


          {rightSidebarOpen == 'history' &&
            <div className="col-sm-12">

              <div className="options-container">
                <div className="export-title">Hide Columns</div>
                {allColumns && allColumns.map(({ Header, accessor, show }, index) => {
                  show == undefined ? show = true : show = show;
                  return (<div key={index} className={`form-group form-check `}>
                    <input
                      type="checkbox"
                      className="form-check-input hidecolumns"
                      checked={(hiddenColumns[accessor] || !show) ? true : false}
                      onChange={e => handleToggleColumn(accessor, e.target.checked, { props })}
                    />
                    <label onClick={e => handleToggleColumn(accessor, (hiddenColumns[accessor] || !show) ? false : true, { props })} className="form-check-label">
                      {Header} &nbsp;
                    </label>
                  </div>);
                }
                )}
              </div>
            </div>
          }

          {rightSidebarOpen == 'table' &&
            <div className="col-sm-12">

              {/* 
          <div className="options-container">
            <div className="export-title">Hide Columns</div>
            {allColumns && allColumns.map(({ Header, accessor, show }, index) => {
              show == undefined ? show = true : show = show;
              return (<div key={index} className={`form-group form-check `}>
                <input
                  type="checkbox"
                  className="form-check-input hidecolumns"
                  checked={(hiddenColumns[accessor] || !show) ? true : false}
                  onChange={e => handleToggleColumn(accessor, e.target.checked, { props })}
                />
                <label onClick={e => handleToggleColumn(accessor, (hiddenColumns[accessor] || !show) ? false : true, { props })} className="form-check-label">
                  {Header} &nbsp;
                          </label>
              </div>);
            }
            )}
          </div> */}
            </div>
          }

          {rightSidebarOpen == 'share' &&
            <div className="col-sm-12">
              <div className="options-container-last">
                <div className="row">
                  {shareOptions.map(({ id, icon, label, style }, idx) =>
                    <div key={idx} className={`col-sm-6 chart-icon-container ${shareopt == id ? 'selected' : ''}`} style={{ textAlign: "center", marginBottom: 20 }}>
                      <div className="hand" onClick={() => handleShareClick(id)}>
                        <RelevantIcon icon={icon} style={{ fontSize: 50, ...style }} />
                      </div>
                      <div className="hand" style={{ color: "gray" }}>
                        {label}
                      </div>
                    </div>
                  )}
                </div>
                <div className="row">
                  {shareopt == 'whatsapp' &&
                    <div className="col-sm-12">
                      <div style={{ float: "left", width: "80%", border: "1px solid gray" }}>
                        <input placeholder="Mobile" style={{ border: 0 }} value={mobile} onChange={(e) => setMobile(e.target.value)} />
                      </div>
                      <div style={{ float: "left", width: "18%", marginLeft: "2%" }}>
                        <span onClick={() => handleShare('whatsapp')} className="sharebtn">Share</span>
                      </div>
                    </div>
                  }
                  {shareopt == 'email' &&
                    <div className="col-sm-12">
                      <div style={{ float: "left", width: "80%", border: "1px solid gray" }}>
                        <input placeholder="Email" style={{ border: 0 }} value={mobile} onChange={(e) => setMobile(e.target.value)} />
                      </div>
                      <div style={{ float: "left", width: "18%", marginLeft: "2%" }}>
                        <span onClick={() => handleShare('email')} className="sharebtn">Share</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          {rightSidebarOpen == 'print' &&
            // get export definitions from this page.
            <div className="col-sm-12">

              <div className="options-container">
                <div className="export-title">PDF</div>
                <div className="row">
                  <div className="col-sm-12 field">
                    <select
                      className="form-control form-control-sm"
                      value={
                        fileFolder.pageOrientation
                          ? fileFolder
                            .pageOrientation
                          : "portrait"
                      }
                      onChange={(e) => setPageOrientation(e, props)}
                    >
                      <option value="portrait">Portrait </option>
                      <option value="landscape">Landscape </option>
                    </select>
                  </div>

                  <div className="col-sm-12 field">
                    <select
                      className="form-control form-control-sm"
                      value={
                        pdfProps.pageSize
                          ? fileFolder.pageSize
                          : "A4"
                      }
                      onChange={(e) => setPageSize(e, props)}
                    >
                      <option value="A4">A4</option>
                      <option value="A3">A3</option>
                      <option value="A2">A2</option>
                      <option value="A1">A1</option>
                      <option value="A0">A0</option>
                      <option value="legal">legal</option>
                    </select>
                  </div>

                  {pivot &&
                    <div className="col-sm-12 field">
                      {!pdfdownloading &&
                        <Button
                          outline
                          size="sm"
                          id="pdf-download-button"
                          className="col-sm-12"
                          onClick={() => clickButton('pdf-download-button-cont')}
                        >
                          <FaFilePdf /> PDF As Shown
                        </Button>
                      }
                      {pdfdownloading && <div>Downloading, Please wait ...</div>}
                    </div>
                  }
                  <div className="col-sm-12 field">
                    {!pdfdownloadingfull &&
                      <Button
                        outline
                        size="sm"
                        id="pdf-download-button"
                        className="col-sm-12"
                        onClick={() => clickButton('pdf-download-button-full')}
                      >
                        <FaFilePdf /> PDF Full Report
                      </Button>
                    }
                    {pdfdownloadingfull && <div>Downloading, Please wait ...</div>}
                  </div>
                </div>
              </div>

              {textReportProps && !textdownloading &&
                <div className="row">
                  <div className="col-sm-12">
                    <div className="options-container">
                      <div className="export-title">TEXT</div>
                      <div className="row">
                        <div className="col-sm-12 field">
                          <select
                            className="form-control form-control-sm"
                            value={textPageSize}
                            onChange={(e) => props.liftGlobalState({ name: "textPageSize" }, e.target.value)}
                          ><option value="select" >Select</option>
                            {
                              textReportProps && Object.keys(textReportProps).map((wdt, idx) => <option key={idx} value={`${wdt}`}>{wdt}</option>)
                            }
                          </select>
                        </div>


                        {pivot && textPageSize &&
                          <div className="col-sm-12 field">
                            <Button
                              outline
                              className="col-sm-12"
                              size="sm"
                              id="text-download-button"
                              onClick={() => clickButton("text-download-button-cont")}
                            >
                              <FaFileDownload /> TEXT As Shown
                            </Button>
                          </div>
                        }
                        {textPageSize &&
                          <div className="col-sm-12 field">
                            <Button
                              outline
                              className="col-sm-12"
                              size="sm"
                              id="text-download-button"
                              onClick={() => clickButton("text-download-button-full")}
                            >
                              <FaFileDownload /> TEXT Full Report
                            </Button>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
              {textReportProps && textdownloading &&
                <div className="col-sm-12 options-container">
                  ... Downloading
                </div>
              }
              {!textReportProps && <div className="col-sm-12 options-container">Text reports are not enabled for this page.</div>}

              <div className="options-container-last">
                <div className="row">
                  <div className="col-sm-12 field">
                    <Button
                      outline
                      size="sm"
                      id="xlsx-download-button"
                      className="col-sm-12"
                      onClick={() => clickButton("xlsx-download-button-full")}
                    >
                      <FaFileExcel /> XLSX
                    </Button>
                  </div>

                  <div className="col-sm-12 field">
                    <Button
                      outline
                      size="sm"
                      id="excel-download-button"
                      className="col-sm-12"
                      onClick={() => clickButton("csv-download-button-full")}
                    >
                      <FaFileExcel /> CSV
                    </Button>
                  </div>

                  {/* <div className="col-sm-12 field">
                    <Button
                      outline
                      size="sm"
                      id="xml-download-button"
                      className="col-sm-12 "
                    >
                      <FaFileCode /> XML
                    </Button>
                  </div>
                  <div className="col-sm-12 field">
                    <Button
                      outline
                      size="sm"
                      id="image-download-button"
                      className="col-sm-12 "
                    >
                      <FaFileImage /> Image
                    </Button>
                  </div> */}


                </div>
              </div>

            </div>
          }

          {rightSidebarOpen == 'charting' &&
            <div className="col-sm-12">
              <div className="options-container-last">
                <div className="row">
                  {chartBoxOpen &&
                    <div className="col-sm-12">
                      <ChartSettings chartType={chartBoxOpen} props={props} />
                    </div>
                  }

                  {!chartBoxOpen &&
                    chartOptions.map(({ id, icon, label, style }, idx) =>
                      <div key={idx} className={`col-sm-4 chart-icon-container ${chartBoxOpen == id ? 'selected' : ''}`} style={{ textAlign: "center", marginBottom: 20 }}>
                        <div className="hand" onClick={() => handleChartClick(id)}>
                          <RelevantIcon icon={icon} style={{ color: "#3282b8", fontSize: 50, ...style }} />
                        </div>
                        <div className="hand" style={{ color: "gray" }}>
                          {label}
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          }

        </div>
      }


    </div>
  );
}

export default GeneralControls;